import React, { useEffect } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { BuildOutlined } from '@mui/icons-material';
import { Logo } from '../widgets/Logo';
import { font } from '../../utils/fontHelper';
import { forceRefreshAppConfig, getAppConfig } from '@watchlist/shared';

const MaintenanceScreen: React.FC = () => {
  const theme = useTheme();

  // Poll every 30s with a forced fresh RC fetch — detects when maintenance is lifted
  useEffect(() => {
    const interval = setInterval(async () => {
      await forceRefreshAppConfig();
      if (!getAppConfig().appMaintenanceMode) {
        window.location.reload();
      }
    }, 30_000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: theme.palette.background.default,
        p: { xs: 3, sm: 4 },
        textAlign: 'center',
      }}
    >
      <Box sx={{ mb: { xs: 4, sm: 6 } }}>
        <Logo size="large" variant="default" state="static" />
      </Box>

      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: '50%',
          bgcolor: theme.palette.warning.main + '22',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
        }}
      >
        <BuildOutlined sx={{ fontSize: 36, color: theme.palette.warning.main }} />
      </Box>

      <Typography
        variant="h5"
        sx={{ ...font('bold'), mb: 1.5, color: theme.palette.text.primary }}
      >
        We'll be back soon
      </Typography>

      <Typography
        variant="body1"
        sx={{ color: theme.palette.text.secondary, maxWidth: 320 }}
      >
        Watchlist is temporarily unavailable. Check back shortly.
      </Typography>
    </Box>
  );
};

export default MaintenanceScreen;
